import { useNavigate } from "react-router-dom";
import styles from "./PreviewBanner.module.css";

const PREVIEW_KEY = "sq_preview";

export function setPreviewMode(): void {
  localStorage.setItem(PREVIEW_KEY, "1");
}

export function clearPreviewMode(): void {
  localStorage.removeItem(PREVIEW_KEY);
}

export function isPreviewMode(): boolean {
  // Never show preview banner when a real kid has authenticated via PIN
  if (localStorage.getItem("sq_kid_id")) return false;
  return localStorage.getItem(PREVIEW_KEY) === "1";
}

export default function PreviewBanner() {
  const navigate = useNavigate();

  if (!isPreviewMode()) return null;

  function exit() {
    clearPreviewMode();
    navigate("/parent");
  }

  return (
    <div className={styles.banner}>
      <span className={styles.label}>👁 Parent Preview Mode</span>
      <button type="button" className={styles.exit} onClick={exit}>
        ← Exit Preview
      </button>
    </div>
  );
}
